import React from "react";
import Marquee from "react-fast-marquee";

export default function EchoMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="py-10 border-y border-white/10 bg-black overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        <span className="font-display text-6xl md:text-8xl font-extrabold tracking-tighter text-outline px-8">
          LEAVE AN ECHO WORTH REMEMBERING
        </span>
        <span className="font-display text-6xl md:text-8xl font-extrabold tracking-tighter text-white px-8">
          — GHOSTLINE
        </span>
      </Marquee>
    </section>
  );
}
